export default class Tips {
    constructor() {
        this.help = [
            { tipId: "stockProduct", message: "Selecione esta opção para cadastrar um equipamento. Ex: Caixa de Som, Martelete..." },
            { tipId: "stockAccessory", message: "Selecione esta opção para cadastrar um acessório. Ex: Cabo de Energia, Suporte..." },
            { tipId: "stockService", message: "Selecione esta opção para cadastrar um serviço. Ex: Entrega, Limpeza, Técnico..." }
        ]
    }
}
